import Icon from './icon';
export default {
  Icon,
  title: 'Polyline',
  hotkey: 'l'
};